'use client';
import { useState, useEffect, useCallback } from 'react';

interface Toast {
  id: string;
  message: string;
  type: 'error' | 'warning' | 'success';
  timestamp: number;
}

interface ToastNotificationsProps {
  toasts: Toast[];
  onDismiss: (id: string) => void;
}

export default function ToastNotifications({ toasts, onDismiss }: ToastNotificationsProps) {
  useEffect(() => {
    const timers = toasts.map(t =>
      setTimeout(() => onDismiss(t.id), 10000)
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, onDismiss]);

  return (
    <div className="fixed top-4 right-4 z-40 flex flex-col gap-2 max-w-sm">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`px-4 py-3 rounded-lg shadow-lg text-white text-sm flex items-center gap-2 animate-slide-in ${
            toast.type === 'error' ? 'bg-red-600' : toast.type === 'warning' ? 'bg-orange-500' : 'bg-green-600'
          }`}
        >
          <span className="flex-1">{toast.message}</span>
          <button onClick={() => onDismiss(toast.id)} className="text-white/80 hover:text-white text-lg">&times;</button>
        </div>
      ))}
    </div>
  );
}

export type { Toast };
